module.exports = __webpack_public_path__ + "static/media/sport.59d7435f.jpg";